import { PaginationResults } from "src/types";
import { get, put } from "../utils";
import { PaginatedAtsJobApplicationParams } from "./type";
import { AtsJobApplication } from "src/types/models/AtsJobApplication";

export async function getAtsJobsApplicationsPaginated(
  queryParams: PaginatedAtsJobApplicationParams
): Promise<PaginationResults<AtsJobApplication>> {
  return (await get({ path: "outdefine_hire/ats_job_application", queryParams })).body;
}

export async function declineAtsJobApplication(id: number): Promise<AtsJobApplication> {
  return (
    await put({ path: "outdefine_hire/ats_job_application", suffix: "decline", body: { id } })
  ).body.application;
}
